<template>
    <main class="container">
        <section>
            <h1>
                <template v-if="route.meta.mode == 'setup'">Setup Internet</template>
                <template v-else>Internet Status</template>
            </h1>
            <p>Please plugin a ethernet cable or setup a wifi connection</p>
        </section>

        <template v-if="GoConnect.loading.networkAdapters">
            <section id="internet-status" class="networkStatus">
                <div class="spinner-border" role="status" style="width: 6rem; height: 6rem; margin: 1rem;">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p id="loading_text"> Refreshing network details please wait...</p>
            </section>
        </template>
        <template v-else>

            <section id="internet-status" class="networkStatus">
                <template v-if="GoConnect.device.hasInternetAccess">
                    <i class="fas fa-cloud fa-2x" style="color: var(--bs-success)"></i>
                    <h3>Has internet connection</h3>
                </template>
                <template v-else>
                    <i class="fas fa-cloud fa-2x" style="color: var(--bs-danger)"></i>
                    <h3>No Internet connectivity</h3>
                </template>
            </section>

            <section id="ethernet-status" class="networkStatus">
                <template v-if="GoConnect.device.networkAdapters['eth0']">
                    <template
                        v-if="GoConnect.device.networkAdapters['eth0'].internet_access && !(GoConnect.device.networkAdapters['eth0'].ping_result.includes('FAIL'))">
                        <i class="fas fa-ethernet fa-2x" style="color: var(--bs-success)"></i>
                        <h3>Ethernet cable plugged in</h3>
                        <p>{{ GoConnect.device.networkAdapters['eth0'].ping_result }}</p>
                    </template>
                    <template
                        v-else-if="GoConnect.device.networkAdapters['eth0'].ping_result && GoConnect.device.networkAdapters['eth0'].ping_result.includes('FAIL')">
                        <i class="fas fa-ethernet fa-2x" style="color: var(--bs-warning)"></i>
                        <h3>Ethernet interface has network connection but no internet connection</h3>
                    </template>
                    <template v-else-if="GoConnect.device.networkAdapters['eth0'].network_access">
                        <i class="fas fa-ethernet fa-2x" style="color: var(--bs-warning)"></i>
                        <h3>Ethernet interface has network connection but no internet connection</h3>
                    </template>
                    <template v-else>
                        <i class="fas fa-ethernet fa-2x" style="color: var(--bs-danger)"></i>
                        <h3>Ethernet cable not plugged in</h3>
                    </template>
                </template>
                <template v-else>
                    <i class="fas fa-ethernet fa-2x" style="color: var(--bs-danger)"></i>
                    <h3>Ethernet cable not plugged in</h3>
                </template>
            </section>

            <section id="wifi-status" class="networkStatus">
                <template v-if="GoConnect.device.networkAdapters['wlan0']">
                    <template
                        v-if="GoConnect.device.networkAdapters['wlan0'].internet_access && !(GoConnect.device.networkAdapters['wlan0'].ping_result.includes('FAIL'))">
                        <i class="fas fa-wifi fa-2x" style="color: var(--bs-success)"></i>
                        <h3>Wi-Fi connected</h3>
                        <p>{{ GoConnect.device.networkAdapters['wlan0'].ping_result }}</p>
                    </template>
                    <template
                        v-else-if="GoConnect.device.networkAdapters['wlan0'].ping_result && GoConnect.device.networkAdapters['wlan0'].ping_result.includes('FAIL')">
                        <i class="fas fa-sim-card fa-2x" style="color: var(--bs-warning)"></i>
                        <h3>Wi-Fi has network connection but no internet connection 2</h3>
                    </template>
                    <template v-else-if="GoConnect.device.networkAdapters['wlan0'].network_access">
                        <i class="fas fa-wifi fa-2x" style="color: var(--bs-warning)"></i>
                        <h3>Wi-Fi has network connection but no internet connection</h3>
                    </template>
                    <template v-else>
                        <i class="fas fa-wifi fa-2x" style="color: var(--bs-danger)"></i>
                        <h3>No Wi-Fi network connected</h3>
                    </template>
                </template>
                <template v-else>
                    <i class="fas fa-wifi fa-2x" style="color: var(--bs-danger)"></i>
                    <h3>No Wi-Fi network connected</h3>
                </template>
            </section>

            <section v-if="GoConnect.device.networkAdapters['dongle0']" id="dongle-status" class="networkStatus">
                <template
                    v-if="GoConnect.device.networkAdapters['dongle0'].internet_access && !(GoConnect.device.networkAdapters['dongle0'].ping_result.includes('FAIL'))">
                    <i class="fas fa-sim-card fa-2x" style="color: var(--bs-success)"></i>
                    <h3>4G / 5G Dongle connected</h3>
                    <p>{{ GoConnect.device.networkAdapters['dongle0'].ping_result }}</p>
                </template>
                <template
                    v-if="GoConnect.device.networkAdapters['dongle0'].ping_result && GoConnect.device.networkAdapters['dongle0'].ping_result.includes('FAIL')">
                    <i class="fas fa-sim-card fa-2x" style="color: var(--bs-warning)"></i>
                    <h3>4G / 5G Dongle has network connection but no internet connection</h3>
                </template>
                <template v-else-if="GoConnect.device.networkAdapters['dongle0'].network_access">
                    <i class="fas fa-sim-card fa-2x" style="color: var(--bs-warning)"></i>
                    <h3>4G / 5G Dongle has network connection but no internet connection</h3>
                </template>
                <template v-else>
                    <i class="fas fa-sim-card fa-2x" style="color: var(--bs-danger)"></i>
                    <h3>4G / 5G Dongle not connected</h3>
                </template>
            </section>
        </template>

        <div class=" row">
            <div class="col-2"><button class="btn btn-dark btn-lg" @click="router.back(-1)">
                    <i class="fas fa-arrow-left"></i>
                </button>
            </div>
            <template v-if="route.meta.mode == 'setup'">
                <div class="col-5">
                    <router-link class="btn btn-dark btn-lg" to="/setup/4">
                        Setup Wi-Fi
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link class="btn btn-dark btn-lg" to="/device/audio">
                        Continue
                    </router-link>
                </div>
            </template>
            <template v-else>
                <div class="col-10">
                    <router-link class="btn btn-dark btn-lg" to="/device/wireless">
                        Setup Wi-Fi
                    </router-link>
                </div>
            </template>
        </div>
    </main>
</template>

<script setup>
import { inject, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const GoConnect = inject('GoConnect');

onMounted(() => {
    try {
        /*if (GoConnect.device.name === null || GoConnect.device.name.trim() === '') {
            GoConnect.onDisconnect();
        }*/

        GoConnect.sendMessage({ type: 'get_internet_status' });
    } catch (error) {
        GoConnect.handleError(error);
    }
});

</script>

<style scoped>
.networkStatus {
    text-align: center;
    border-bottom: var(--bs-border-width) var(--bs-border-color) var(--bs-border-style);
}

.networkStatus:last-of-type {
    border-bottom: 0;
}
</style>
